import { Controller } from "@hotwired/stimulus";
import { safeParse } from "../utils/cart_utils";

// Keeps the checkout form in sync with the cart stored in localStorage.
export default class extends Controller {
  static targets = ["payload", "checkoutBtn"];

  submitCart(event) {
    // Populate hidden payload input with cart data from localStorage
    // just before the form is submitted.
    // Disable the submit button to prevent double submits.
    // Show a loading state on the button.

    // event.submitter is the button that was clicked to submit the form
    // (or undefined if the form was submitted via JS).
    // We use it to disable the button and show a loading state.
    // If it's not available, we fall back to the checkoutBtnTarget.

    // Read cart from localStorage
    const cart = safeParse(localStorage.getItem("cart")) || [];

    if (!Array.isArray(cart) || cart.length === 0) {
      // Prevent form submission and show an error in the console.
      event.preventDefault();
      console.error("Attempted to submit empty cart, aborting.");
      return;
    }

    // Populate hidden payload input
    this.payloadTarget.value = JSON.stringify(cart);

    // Store original button text in data attribute to restore later
    this.checkoutBtnTarget.dataset.originalText = this.checkoutBtnTarget.textContent?.trim() || "";
    // Disable submit button and show loading state
    this.checkoutBtnTarget.disabled = true;
    this.checkoutBtnTarget.textContent = "Loading checkout…";

    // Let Turbo handle the actual submission so we get a Turbo Stream request
  }

  reset() {
    // Re-enable the "Proceed to Checkout" button so the user can try again and restore its label.
    this.checkoutBtnTarget.disabled = false;
    const label = this.checkoutBtnTarget.dataset.originalText;
    if (label) this.checkoutBtnTarget.textContent = label;
  }
}
